import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id AA43B04E-7C56-4DFB-83FC-081E3A4A3F48
 * name car-door
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-door.svg
 * tags
 * - Automotive 
 */
export const CarDoorIcon = createSvgIcon(<><path d="M19,14H16V16H19V14M22,21H3V11L11,3H21A1,1 0 0,1 22,4V21M11.83,5L5.83,11H20V5H11.83Z" /></>, 'CarDoorIcon');
export default CarDoorIcon